import { render, staticRenderFns } from "./LaborProtectionChecklistForm.vue?vue&type=template&id=5caf66e1&"
import script from "./LaborProtectionChecklistForm.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionChecklistForm.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionChecklistForm.vue?vue&type=style&index=0&id=5caf66e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports